import './PublicRoute.less';
import { Suspense } from 'react';
import { Outlet, Link } from 'react-router-dom';
import Loader from './common/Loader.jsx';
import ErrorBoundaryWrapper from '../hoc/ErrorBoundary.jsx';

import logo from '../assets/images/logo-new.svg';

const currentYear = new Date().getFullYear();

const PublicRoute = () => {
    return (
        <ErrorBoundaryWrapper>
            <div className="public public__container">
                <header className="public__header">
                    <Link to="/" className="public__logo">
                        <img className="img-responsive" src={logo} alt="Existek" />
                    </Link>
                </header>
                <div className="public__main">
                    <Suspense fallback={<Loader />}>
                        <Outlet />
                    </Suspense>
                </div>
                <footer className="public__footer">Copyright &copy; Existek 2012 - {currentYear}</footer>
            </div>
        </ErrorBoundaryWrapper>
    );
};

export default PublicRoute;
